// Requires: src/myProduct.js
// Requires: src/register-product.sectionManager.js
// Requires: src/register-product.promoErrorManager.js

window.BOL.RegisterProduct.promoManager = (function($, sectionManager, promoErrorManager, myProduct) {
	'use strict';

	var SELECTORS = {
		form:         '[data-product-promoform]',
		field:        '[data-promofields-code]',
		button:       '[data-promofields-button]',
		text:         '[data-promo-text]',
		currentState: '[data-promo-state]',
		baseClass:    'online--product-result-details__promo-state',
		loading:      '--loading',
		successClass: '--success'
	};

	var REQUEST_URL;

	/* ------------------------------------
	Update once integrated: Start
	---------------------------------------*/
	// DEV ENVIRONMENT
	// If Styleguide Environment
	if (window.envStyleguide) {
		REQUEST_URL = '/_sg-client/example_data/add-code-to-product.json';
		// LIVE ENVIRONMENT
	} else {
		REQUEST_URL = '/api/sitecore/Promocode/ValidatePromoCode';
	}
	/* ------------------------------------
	Update once integrated: End
	---------------------------------------*/

	var $form         = $(SELECTORS.form);
	var $field        = $(SELECTORS.field);
	var $button       = $(SELECTORS.button);
	var $text         = $(SELECTORS.text);
	var $currentState = $(SELECTORS.currentState).eq(0);
	var currentProduct;
	var successCallback;
	var currentProductId;

	function resetState() {
		$currentState.attr('class', SELECTORS.baseClass);
	}

	function setState(state) {
		resetState();
		$currentState.addClass(SELECTORS.baseClass + state);
	}


	function showDefaultPurchaseDateText(boolean) {
		if(boolean) {
			$text.show();
			return;
		}

		$text.hide();
		return;
	}

	function reset() {
		$form.show();
		promoErrorManager.hideError();
		// $field.removeAttr('disabled');
		// $button.removeAttr('disabled');
	}

	function success() {
		promoErrorManager.hideError();
	}

	function displayError(message) {
	    promoErrorManager.showError(message);
	    resetState();
	}

	function handleSuccessfulCode(serial) {
		myProduct.addPromo(serial);
		success();
		$field.attr('disabled', 'disabled');
		$button.attr('disabled', 'disabled');
		setState(SELECTORS.successClass);
	}

	function handlePromoCodeRequest(responseData, serial) {
		if(typeof responseData === 'object') {
			if( !responseData.error && responseData.hasOwnProperty('message')) {
				handleSuccessfulCode(serial);
			} else {
				resetState();
				displayError(responseData.error.message);
			}
		} else {
			resetState();
			displayError();
		}
	}

	function handlePromoSubmit(event) {
		var requestData = {};

		event.preventDefault();
		event.stopImmediatePropagation();

		var inputValue = $field.val();

		if(inputValue.length <= 0) {
		  displayError();
		  return;
		}

		setState(SELECTORS.loading);

		requestData.ProductId = currentProductId;
		requestData.Promocode = inputValue;

		// DEV ENVIRONMENT
		// If Styleguide Environment
		if (window.envStyleguide) {

			/*
			Code for styleguide only START
			*/
			if (requestData.Promocode === 'FREE') {
				REQUEST_URL = '/_sg-client/example_data/add-code-to-product.json';
			} else if (requestData.Promocode === 'OTHER') {
				REQUEST_URL = '/_sg-client/example_data/add-code-to-product-fail.json';
			}
			/*
			Code for styleguide only END
		*/
		
		 $.get(REQUEST_URL, requestData)
			.done(function(responseData){
				handlePromoCodeRequest(responseData, requestData.ProductId);
			})
			.fail(function() {
				resetState();
				displayError();
			});
		// LIVE ENVIRONMENT
		} else {
			$.post(REQUEST_URL, requestData)
			.done(function(responseData){
				handlePromoCodeRequest(responseData, requestData.ProductId);
			})
			.fail(function() {
				displayError();
			});
		}
	}

	function setCurrent(serialNo, ProductId) {
		currentProduct   = serialNo;
		currentProductId = ProductId;
	}

	function init(callback) {
		successCallback = callback;

		$form.validator({
		    disable: false,
		    focus: false
		});

		$($form).submit(handlePromoSubmit);
		promoErrorManager.init();
	}

	function setFormVisibility(isVisible) {
		if(isVisible) {
			promoErrorManager.hideError();
			resetState();
			$form.show();
		} else {
			$form.hide();
		}
	}

	return {
		init:              init,
		reset:             reset,
		setCurrent:        setCurrent,
		setFormVisibility: setFormVisibility,
		showDefaultPurchaseDateText: showDefaultPurchaseDateText
	};

})($jq, window.BOL.RegisterProduct.sectionManager, window.BOL.RegisterProduct.promoErrorManager, window.BOL.myProduct);
